"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sitesGtmCodes = Object.freeze({
  BMAR: 'GTM-NQWSPT',
  BMCL: 'GTM-M9GZDZ',
  BMEC: 'GTM-PLWWMF',
  BMMX: 'GTM-WQD9M5',
  BMPA: 'GTM-WQ5R5Q',
  BMPE: 'GTM-T2KSVF',
  BMVE: 'GTM-KL3KFZ',
  ZJAR: 'GTM-SSLF'
});